(ns ycweb.app.website.dlp.widgets.buttonrow
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.scroll :as scroll]
   [clojure.string :as str]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.util.core :as u]))

(defn build-m-buttons [button-number num-buttons button-align-left button-1-style properties]
  (let [button-text (get properties (keyword (str "button-row/button-" button-number "-text")))
        button-url (get properties (keyword (str "button-row/button-" button-number "-url")))
        button-link-type (get properties (keyword (str "button-row/button-" button-number "-link-type")))
        button-icon (get properties (keyword (str "button-row/button-" button-number "-icon")))
        onpage? (= button-link-type "onpage")]
    [:div
     {:class
      (u/bem :flex-grid-block
        [(when (and (not= button-number 2) (= num-buttons 2)) [:m-order-02])

         (cond
           button-align-left
           :m-fluid

           (<= button-number num-buttons)
           (cond
             (= num-buttons 4)
             [:t-1-2 :ml-1-4]

             (= num-buttons 3)
             :m-1-3

             (= num-buttons 2)
             [:m-1-2]

             (= num-buttons 1)
             :full))])}
     [:div.flex-grid-content
      (buttons/button-web button-text
        (merge
          (when onpage?
            (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace button-url #"\#" ""))))
          {:href button-url
           :style
           (if (and (= button-number 1) (< num-buttons 3))
             (or (keyword button-1-style) :primary)
             :secondary)
           :size :default
           :full true
           :class (when (= button-link-type "help") "js-mfp-open-url")
           :icon (when (and (<= button-number 2) (< num-buttons 3)) (keyword button-icon))
           :icon-placement (if (= button-icon "arrow-right") :right :left)
           :custom-attrs
           (when (= button-link-type "help")
             {:target_url (str button-url "&overrideincludes=blank")
              :data-content-wrapper-class "yc-simple-text"})}))]]))

(rum/defc button-row [_ page component]
  (let [{:button-row/keys [button-1-text button-1-url button-1-style number-of-buttons button-align-left show-content?]}
        (:properties component)
        num-buttons (trf/tonumber number-of-buttons)]
    [:<>
     (when
      (and
        show-content?
        button-1-text
        button-1-url)
       [:div.yc-section
        [:div
         {:class
          (cond
            (not button-align-left)
            (str "u-block-center"
              (cond
                (= num-buttons 2)
                " u-max-width-480"

                (= num-buttons 1)
                " u-max-width-240"))

            (and button-align-left (trf/toboolean (:isarticle page)))
            "u-block-center  u-max-width-720")}
         [:div
          {:class (u/bem :flex-grid-group [:flush :flush-force (when button-align-left :align-left)])}
          (map
            (fn [c]
              (build-m-buttons c num-buttons button-align-left button-1-style (:properties component)))
            (range 1 (inc num-buttons)))]]])]))
